export default "/assets/images/apple-store.svg?6be3e941df6ed728fe56ee8feae2de9e";